export const ChevronDownIcon = () => (
    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            id="Icon/Chevron"
            d="M6.99995 6.09468L11.8573 1.2491C12.3474 0.760106 13.1422 0.760106 13.6324 1.2491C14.1225 1.7381 14.1225 2.53091 13.6324 3.01991L7.88749 8.7509C7.3973 9.2399 6.60256 9.2399 6.11238 8.75089L0.367625 3.0199C-0.122549 2.5309 -0.122541 1.73808 0.367644 1.24909C0.857829 0.760102 1.65257 0.76011 2.14274 1.24911L6.99995 6.09468Z"
            fill="#A4343A"
        />
    </svg>
);
